import { Order } from 'config/constants'
import { useState } from 'react'

export default function useTableSort([defaultOrderBy, defaultOrder]) {
  const [orderBy, setOrderBy] = useState([defaultOrderBy])
  const [order, setOrder] = useState(defaultOrder)

  const getSorted = name => {
    if (orderBy.includes(name))
      return order === Order.ASC ? 'ascending' : 'descending'

    return null
  }

  const handleSort = name => _ => {
    if (orderBy.includes(name)) {
      if (order === Order.ASC) setOrder(Order.DESC)
      else setOrder(Order.ASC)
    } else {
      setOrderBy([name])
      setOrder(Order.DESC)
    }
  }

  return [orderBy, order, getSorted, handleSort]
}
